import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';

const PlayerItem = ({ active, player, rounded, style, showIcons }) => {
    const headshotFallback = 'https://content.mlb.com/images/headshots/current/60x60/generic.png';

    return (
        <li className="p-player-item" style={style}>
            <a href={player.url}>
                <div className="p-player-item__container">
                    <div className={classNames('p-player-item__image', {'p-player-item__image--rounded': rounded})}>
                        <div
                            className={classNames(
                                'p-player-item__image-selector',
                                {
                                    'p-player-item__image-selector--rounded': rounded, 
                                    'p-player-item__image-selector--active': active 
                                }
                            )}
                        />
                        <img
                            className={classNames('p-player-item__image-headshot', {'p-player-item__image-headshot--rounded': rounded})}
                            src={`https://content.mlb.com/images/headshots/current/60x60/${player.id}.png`}
                            alt={player.name}
                            onError={(e) => { e.target.src = headshotFallback; }}
                        />
                    </div>
                    <div className="p-player-item__info">
                        <span>{player.name}</span>
                    </div>
                    {player.teamId && showIcons &&
                        <div className="p-player-item__team-logo--container">
                            <img className="p-player-item__team-logo" src={`https://www.mlbstatic.com/team-logos/${player.teamId}.svg`} />
                        </div>
                    }
                </div>
            </a>
        </li>
    )
}

PlayerItem.propTypes = {
    active: PropTypes.bool.isRequired,
    player: PropTypes.shape({}).isRequired,
    style: PropTypes.shape({}).isRequired
}

export default PlayerItem
